/**
 * LEGACY (2026-10-14): deprecated old ABM page, superseded by AbmBeta (labelled
 * "ABM", path `abm-beta`). Shown only on the Bluewhale white label
 * (VITE_APP=BLUEWHALERESEARCH) as "ABM (Legacy)"; every other brand redirects
 * `abm` to `abm-beta`. Still imported by Dashboard (abm.hook/data) — do not delete.
 */
import { lazy } from "react";
const Abm = lazy(() => import("@/modules/Report/AbmNew"));

const AbmNewRoutes = {
  element: <Abm />,
  path: "abm",
};

export default AbmNewRoutes;
